import { getHondaExpApiHeaders, getHondaExpApiUrl } from '@honda-canada/js-utilities/lib/hondaExpApi';
import useSotHondaExpApiConfig from '../../../utils/sitecoreContext/useSotHondaExpApiConfig';
import { useLanguage } from '../../../utils/sitecoreContext';
const NPE = ['sit', 'uat', 'dit'];
const useManualSotExpApiConfig = () => {
    const config = useSotHondaExpApiConfig();
    const language = useLanguage();
    const { env, publicationsApiConsumerId: consumerId, publicationsApiConsumerName: consumerName, publicationsApiUseAlternativeBaseUrl, } = config || {};
    const headers = getHondaExpApiHeaders({ consumerId, consumerName, language });
    // env is excluded from production url
    const targetEnv = NPE.includes(env) ? env : '';
    // Currently facing some mismatch in url from js-utilities method getHondaExpApiUrl({env, consumerName})
    const baseUrl = publicationsApiUseAlternativeBaseUrl
        ? `https://api${targetEnv}.services.honda.ca/api${targetEnv}-honda-${consumerName}-exp-api/${consumerName}-exp-api/v1`.toLowerCase()
        : getHondaExpApiUrl({
            env,
            consumerName,
        });
    return { headers, baseUrl };
};
export default useManualSotExpApiConfig;
